import React from 'react';
import { defaultMemoize } from 'reselect';

import { IFilterDefinition, ISelectFilterDefinition, ISelectFilterDefinitionOption } from '~content/services/FilterPanelService';
import { AdvancedFilterPanel, AdvancedFilterPanelProps } from '~src/spacesPlatform/components/Explorer/AdvancedFilterPanel';

import { SiteRoleFilterHelper } from '../../../../siteManagement/helpers/SiteRoleFilterHelper';
import { IStringValuedFilterClause } from '../../../../ts/ServerApi/types/IFilterClause';
import { ServerUsers } from '../../../services/resources/ServerUsers';
import { SiteRolesResource } from '../../../services/resources/SiteRoles';
import { ServerUserDefinition } from '../../contentDefinition/ServerUserDefinition';


export interface ServerUsersAdvancedFilterPanelProps extends AdvancedFilterPanelProps {}

export interface ServerUsersAdvancedFilterPanelState {
  siteRoleOptionsWithCounts: ISelectFilterDefinitionOption<string>[];
}

// This function is a weird way to update filter definitions asynchronously
// since those definitions are created in the child component - AdvancedFilterPanel.
// See related comment there.
function transformFilterDefinitions(
  siteRoleOptionsWithCounts: ISelectFilterDefinitionOption<string>[]
): (filterDefinitions: IFilterDefinition<any>[]) => void {
  return (filterDefinitions: IFilterDefinition<any>[]) => {
    if (siteRoleOptionsWithCounts) {
      (filterDefinitions[0] as ISelectFilterDefinition<string>).options = siteRoleOptionsWithCounts;
    }
  };
}

export class ServerUsersAdvancedFilterPanel extends React.Component<ServerUsersAdvancedFilterPanelProps, ServerUsersAdvancedFilterPanelState> {

  private isUnmounted = false;
  private siteRoles: SiteRolesResource = undefined;
  private memoizedTransformFilterDefinitions = defaultMemoize(transformFilterDefinitions);

  public constructor(props: ServerUsersAdvancedFilterPanelProps) {
    super(props);
    this.siteRoles = SiteRolesResource.instance;
    this.state = { siteRoleOptionsWithCounts: null };
  }

  public render() {
    const transformFilterDefinitions = this.memoizedTransformFilterDefinitions(
      this.state.siteRoleOptionsWithCounts
    );
    return <AdvancedFilterPanel {...this.props} transformFilterDefinitions={transformFilterDefinitions} />;
  }

  public componentDidMount() {
    this.updateSiteRoleCounts();
  }

  public componentDidUpdate(prevProps: ServerUsersAdvancedFilterPanelProps) {
    if (this.searchTerm(this.props) !== this.searchTerm(prevProps)) {
      this.updateSiteRoleCounts();
    }
  }

  public componentWillUnmount() {
    this.isUnmounted = true;
  }

  private updateSiteRoleCounts = async () => {
    let query = ServerUserDefinition.getBasicQuery();
    if (this.searchTerm(this.props)) {
      query = query.addFilter(this.props.mixedContentFilterMap.search);
    }
    const userCountsByRole = await ServerUsers.instance.getUserCountsByMaxSiteRole(query);
    const siteRoleOptionsWithCounts = SiteRoleFilterHelper.siteRoleOptions(this.siteRoles.optionsForCurrentUser(), userCountsByRole);

    !this.isUnmounted && this.setState({ siteRoleOptionsWithCounts });
  }

  private searchTerm = (props: ServerUsersAdvancedFilterPanelProps) => {
    return (props.mixedContentFilterMap.search
      && (props.mixedContentFilterMap.search as IStringValuedFilterClause).value)
      || '';
  }
}
